import { Card, TableItem } from "components/atoms";

import ListWrapper from "components/molecules/list-wrapper/ListWrapper";
import { Table } from "components/organisms";
import { useScroll } from "components/templates/application/ApplicationTemplate";
import { useInfiniteTable } from "hooks/useInfiniteTable";
import { useNewWindowNavigate } from "hooks/useNewWindowNavigate";
import { useCustomParamId, useParamId } from "hooks/useParamId";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { useGetContractProducts } from "services/contract/products";

import { PRODUCT_TYPE } from "services/contract/types";

const ContractProductsTab = () => {
  const contractId = useParamId();

  const products = useGetContractProducts(contractId);

  const scroll = useScroll({ fetchNextPage: products.fetchNextPage });

  const tableProps = useInfiniteTable(products);

  const navigateToNewWindow = useNewWindowNavigate();
  const navigate = useNavigate();

  const getProductPath = (product: any) => {
    switch (product.productType?.id) {
      case PRODUCT_TYPE.Digital:
        return `/music-product-digital/${product.id}/data`;

      case PRODUCT_TYPE.Physical:
        return `/music-product-physical/${product.id}/data`;

      case PRODUCT_TYPE.YouTube:
        return `/channel/${product.id}/data`;

      case PRODUCT_TYPE.Merch:
        return `/merch/${product.id}/data`;

      default:
        return `/product/${product.id}/data`;
    }
  };

  return (
    <ListWrapper
      items={products.data?.pages.flat()}
      isLoading={products.isLoading}
      isFetchingNextPage={products.isFetchingNextPage}
      item={(product) => (
        <Card
          key={product.id}
          header={product.title}
          description={product.ean}
          onClick={() => navigate(getProductPath(product))}
        />
      )}
    />
  );
};

export default ContractProductsTab;
